import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function WorkspacePill({ label, swatch, aggregate, count, expanded, onClick, onKeyDown, hint, }) {
    return (_jsxs("button", { type: "button", "data-workspace-pill": true, "data-aggregate": aggregate ? 'true' : undefined, "aria-haspopup": "menu", "aria-expanded": expanded ? 'true' : 'false', onClick: onClick, onKeyDown: onKeyDown, style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 'var(--sp-2)',
            padding: '6px var(--sp-3)',
            background: 'var(--surface-alt)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius-md)',
            color: 'var(--text)',
            fontSize: 'var(--fs-sm)',
            fontWeight: 500,
            cursor: 'pointer',
            minHeight: 32,
            fontFamily: 'inherit',
        }, children: [_jsx("span", { "aria-hidden": true, style: {
                    width: 14,
                    height: 14,
                    borderRadius: 3,
                    background: aggregate
                        ? 'linear-gradient(135deg, var(--band-blue-mark), var(--band-green-mark))'
                        : 'var(--accent)',
                    color: 'var(--cta-text)',
                    fontSize: 9,
                    fontWeight: 700,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }, children: aggregate ? count ?? '' : swatch }), _jsx("span", { children: label }), hint ? (_jsx("span", { style: { color: 'var(--text-dim)', fontSize: 'var(--fs-xs)', marginLeft: 'var(--sp-1)' }, children: hint })) : null, _jsx("span", { "aria-hidden": true, style: { color: 'var(--text-dim)', fontSize: 10 }, children: "\u25BE" })] }));
}
//# sourceMappingURL=WorkspacePill.js.map